import {Base} from "@/api/Base"

export class PlanDelete extends Base {
    path = "plan/delete"
}